import { withStory, WithStoryProps } from '@storyofams/storyblok-toolkit';
import { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';

import { GuideIndexPage } from '~/components/Guides';
import { GuidechapterItems } from '~/graphql/sdk';
import { enhancedStaticProps, withLayout, sdk as sdkClient } from '~/lib';

/** @TODO should be fully dynamic, see issue `WEB-62` */

export interface HeadlessGuideProps extends WithStoryProps {
  guideChapters?: GuidechapterItems;
}

const HeadlessGuide = ({ story, guideChapters }: HeadlessGuideProps) => {
  const router = useRouter();

  return (
    <GuideIndexPage
      story={story}
      slug={router?.route}
      guideChapters={guideChapters}
    />
  );
};

export default withLayout(withStory(HeadlessGuide));

export const getStaticProps: GetStaticProps = enhancedStaticProps(
  async ({ params: { name }, sdk }) => {
    let story;
    let guideChapters;
    let notFound = false;

    try {
      story = (await sdk.guideIndexItem({ slug: `guides/${name}` }))
        .GuideindexItem;
    } catch (e) {
      notFound = true;
    }

    try {
      guideChapters = (
        await sdk.guideChapterItems({ by_slugs: `guides/${name}/*` })
      ).GuidechapterItems;
    } catch (e) {
      notFound = true;
    }

    return {
      props: {
        story,
        guideChapters,
      },
      notFound: notFound || !story,
      revalidate: 60,
    };
  },
);

export const getStaticPaths: GetStaticPaths = async () => {
  let stories;

  try {
    stories = (await sdkClient.guideIndexItems({ by_slugs: 'guides/*' }))
      .GuideindexItems.items;
  } catch (e) {
    console.log(e);
  }

  return {
    paths: stories?.map(({ slug }) => ({
      params: { name: slug },
    })),
    fallback: 'blocking',
  };
};
